<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SettingsAccordion from 'dashboard/components-next/Settings/SettingsAccordion.vue';
import { useBranding } from 'shared/composables/useBranding';

const { t } = useI18n();
const { replaceInstallationName } = useBranding();

const brandNote = computed(() =>
  replaceInstallationName(
    t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.BRAND_NOTE')
  )
);
</script>

<template>
  <SettingsAccordion
    :title="$t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.ACCORDION_TITLE')"
    :default-open="false"
    class="w-full"
  >
    <div class="space-y-4 text-sm leading-relaxed text-n-slate-11">
      <p class="text-n-slate-12 font-medium">
        {{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.INTRO') }}
      </p>
      <div>
        <h3 class="mb-1 text-sm font-semibold text-n-slate-12">
          {{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.WINDOW_TITLE') }}
        </h3>
        <p>{{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.WINDOW_BODY') }}</p>
      </div>
      <div>
        <h3 class="mb-1 text-sm font-semibold text-n-slate-12">
          {{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.TEMPLATES_TITLE') }}
        </h3>
        <p>{{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.TEMPLATES_BODY') }}</p>
      </div>
      <div>
        <h3 class="mb-1 text-sm font-semibold text-n-slate-12">
          {{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.SYNC_TITLE') }}
        </h3>
        <p>{{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.SYNC_BODY') }}</p>
      </div>
      <div>
        <h3 class="mb-1 text-sm font-semibold text-n-slate-12">
          {{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.SEND_TITLE') }}
        </h3>
        <p>{{ $t('INBOX_MGMT.META_MESSAGE_TEMPLATES_HELP.SEND_BODY') }}</p>
      </div>
      <p class="text-xs text-n-slate-11">
        {{ brandNote }}
      </p>
    </div>
  </SettingsAccordion>
</template>
